import React, { FunctionComponent, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { PUBLIC_ROUTES } from "./lazy-loading";
import Loader from "../components/shared/loader";
import { useHandshaking, useSocketConnect } from "../configs/socket";

interface MainRoutesProps {}

/**
 * Main routing component for the application.
 * 
 * - Handles route rendering based on the PUBLIC_ROUTES configuration.
 * - Establishes real-time socket connections and handshake processes.
 * - Wraps the routes in a Suspense fallback while lazy components are loading.
 *
 * @component
 * @returns {JSX.Element} Main application routes with lazy loading support
 */
const MainRoutes: FunctionComponent<MainRoutesProps> = () => {
  useHandshaking();
  useSocketConnect();
  const routes = useRoutes(PUBLIC_ROUTES);
  return <Suspense fallback={<Loader />}>{routes}</Suspense>;
};

export default MainRoutes;
